module.exports = __webpack_public_path__ + "/images/ico-round-fondos-success.9aac856.svg";